module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/新技术研发.fe80c6a1.png";